import { jwtDecode } from "jwt-decode"
import TokenServices from "./token.service"

class UserServices {
  constructor() {
    this.tokenServices = new TokenServices()
  }

  // -------- Check member --------
  get isMember() {
    return this.getUser?.userRole === "member"
  }

  // -------- Check specialist --------
  get isSpecialist() {
    return this.getUser?.userRole === "specialist"
  }

  // -------- Get user --------
  get getUser() {
    const token = this.tokenServices.getAccessToken(true)
    return token ? jwtDecode(token) : null
  }
}

export default UserServices